import React from 'react'

function NoLotCard() {
  return (
    <div className="mt-4 rounded-md bg-white px-6 py-4">No Lots to Display</div>
  )
}

export default NoLotCard
